/**
 * visibleCategories - Filtra categorias exibidas como abas no Kanban.
 *
 * A regra é calculada no servidor (`get_task_categories.has_visible_phase`) a partir das
 * Permissões por Fase do perfil. Campo ausente (ex.: Ordem de Serviço) mantém a categoria.
 *
 * RELEASE: 2026-10-22 v1.0.0 - Criação.
 */
export function filterVisibleCategories<T extends { has_visible_phase?: boolean }>(
  categories: T[] | null | undefined,
): T[] {
  return (categories ?? []).filter((c) => c.has_visible_phase !== false);
}
